'use client';
import * as React from 'react';
import { useMap, Marker } from '@vis.gl/react-google-maps';
import type {
  Location,
  OnMarkerClickedComponentPayload,
} from '../GoogleMap.types';

export interface GoogleMapContentProps {
  locations: Array<Location>;
  onMarkerClicked?: (event: OnMarkerClickedComponentPayload) => void;
  onMapReady: (map: google.maps.Map) => void;
}

export const GoogleMapContent: React.FC<GoogleMapContentProps> = ({
  locations,
  onMarkerClicked,
  onMapReady,
}) => {
  const map = useMap();

  const handleMarkerClick = React.useCallback(
    (index: number, marker: Location) => {
      if (onMarkerClicked) {
        onMarkerClicked({
          type: 'markerClicked',
          title: marker.title,
          description: marker.description,
          address: marker.address,
          location: {
            latitude: marker.latitude,
            longitude: marker.longitude,
          },
        });
      }
    },
    [onMarkerClicked],
  );

  React.useEffect(() => {
    if (map) {
      onMapReady(map);
    }
  }, [map, onMapReady]);

  return (
    <>
      {locations.map((marker, index) => (
        <Marker
          key={`marker-${index}`}
          position={{ lat: marker.latitude, lng: marker.longitude }}
          title={marker.title}
          onClick={() => handleMarkerClick(index, marker)}
        />
      ))}
    </>
  );
};

export default GoogleMapContent;
